@import "./sellalong-panel-purchase-item.css";

.sellalong-panel-purchase-item-title {
  color: var(--sellalong-colour-primary, #000);
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 2.8px;
  line-height: 1.5em;
}

.sellalong-panel-purchase-item-purchase-age {
  color: var(--sellalong-colour-text-light, #777);
  font-size: 11px;
  letter-spacing: 2.2px;
}

.sellalong-panel-purchase-item-message {
  font-family: var(--sellalong-text-font, serif);
  font-size: 13px;
  letter-spacing: 0.8px;
  color: var(--sellalong-colour-text, #000);
  text-transform: none;
}

.sellalong-panel-purchase-item-select-button {
  border-radius: 0;
  letter-spacing: 2.8px;
  font-size: 12px;
  padding: 4px 20px;
}

:host.sellalong-panel-purchase-item-state-tosell
  .sellalong-panel-purchase-item-image {
  border-radius: 0;
}

:host(.sellalong-panel-purchase-item-variant-mini) {
  align-items: flex-start;
  width: auto;
}

:host(.sellalong-panel-purchase-item-variant-mini)
  .sellalong-panel-purchase-item-image {
  height: 120px;
  width: 120px;
}

:host(.sellalong-panel-purchase-item-variant-mini) figure {
  max-width: 165px;
}

:host(.sellalong-panel-purchase-item-sample.sellalong-panel-purchase-item-variant-mini)::before {
  font-size: 28px;
  height: 120px;
  line-height: 120px;
  width: 120px;
}

:host(.sellalong-panel-purchase-item-variant-mini)
  .sellalong-panel-purchase-item-title {
  text-align: left;
  margin: 6px 0 0;
  font-size: 12px;
}

:host(.sellalong-panel-purchase-item-variant-mini)
  .sellalong-panel-purchase-item-name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

:host(.sellalong-panel-purchase-item-variant-mini)
  .sellalong-panel-purchase-item-message {
  text-align: left;
}

:host(.sellalong-panel-purchase-item-variant-mini)
  .sellalong-panel-purchase-item-offer {
  justify-content: left;
  margin-top: 5px;
}

:host(.sellalong-panel-purchase-item-variant-mini)
  .sellalong-panel-purchase-item-select-button {
  font-size: 11px;
  margin-top: 5px;
  line-height: 20px;
}

:host(.sellalong-panel-purchase-item-variant-mini)
  .sellalong-panel-purchase-item-purchase-age {
  margin-bottom: 5px;
  font-size: 10px;
}

@media screen and (max-width: 640px) {
  :host(.sellalong-panel-purchase-item-variant-mini)
    .sellalong-panel-purchase-item-image {
    height: 90px;
    width: 90px;
  }

  :host(.sellalong-panel-purchase-item-variant-mini)
    .sellalong-panel-purchase-item-title {
    font-size: 11px;
  }

  :host(.sellalong-panel-purchase-item-sample.sellalong-panel-purchase-item-variant-mini)::before {
    height: 90px;
    line-height: 90px;
    width: 90px;
  }

  :host(.sellalong-panel-purchase-item-sample.sellalong-panel-purchase-item-variant-mini)
    .sellalong-panel-purchase-item-select-button {
    display: none;
  }

  :host(.sellalong-panel-purchase-item-variant-mini)
    .sellalong-panel-purchase-item-select-button {
    font-size: 10px;
    line-height: 12px;
  }

  :host(.sellalong-panel-purchase-item-variant-mini)
    .sellalong-panel-purchase-item-purchase-age {
    margin-bottom: 2px;
    font-size: 8px;
  }

  :host(.sellalong-panel-purchase-item-variant-mini)
    .sellalong-panel-purchase-item-message {
    font-size: 12px;
  }
}
